<ios-fullscreen-hint
    [closeBtnImg]="closeBtnImg"
    [swipeUpImg]="swipeUpImg"
    [isHintForClosing]="isHintForClosing">
    <div class="ios-fscrn__container--text">
        <p>{{'ENTER_FULLSCREEN' | translate}}</p>
    </div>
    <div class="ios-fscrn__container--hint">
        <div class="ios-fscrn__container--image">
            <img class="ios-fscrn__image--url-bar" [src]="'assets/images/ios-fullscreen/url-bar.png'"/>
        </div>
        <div class="ios-fscrn__container--image arrow">
            <img class="ios-fscrn__image--arrow" [src]="'assets/images/ios-fullscreen/arrow-right.png'"/>
        </div>
        <div class="ios-fscrn__container--image">
            <img class="ios-fscrn__image--toolbar-menu" [src]="'assets/images/ios-fullscreen/toolbar_menu.png'"/>
        </div>
    </div>
</ios-fullscreen-hint>
